<!-- mettal-3\src\components\X1152.vue -->
<template>
	<div :class="[`x1-11`, className || ``]" @click="$emit('click')">
		<!-- Внутренний элемент для отображения border -->
		<div class="card-border-x1"></div>
		<img
			class="image-13"
			src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/---------------21@2x.png"
			alt="image"
		/>
		<div class="view-189">
			<p class="x01-17" lang="ru">
				{{ title || 'Урок 01 : Знакомство с 1С Предприятие' }}
			</p>
			<div class="text-255">
				<svg
					width="23"
					height="19"
					viewBox="0 0 23 19"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M21.1719 0.789062C21.875 0.75 22.5 1.29688 22.4609 1.96094V15.1641C22.4609 15.7891 21.9531 16.3359 21.2891 16.375C19.375 16.4531 15.4688 16.8438 12.7734 18.2109C12.3438 18.4062 11.8359 18.1328 11.8359 17.6641V3.44531C11.8359 3.25 11.9531 3.05469 12.1484 2.9375C14.7656 1.33594 19.0234 0.90625 21.1719 0.789062ZM10.3125 2.9375C10.5078 3.05469 10.625 3.25 10.625 3.44531V17.6641C10.625 18.1328 10.1172 18.4062 9.6875 18.2109C6.99219 16.8438 3.08594 16.4531 1.17188 16.375C0.507812 16.3359 0 15.7891 0 15.1641V1.96094C0 1.29688 0.585938 0.75 1.28906 0.789062C3.4375 0.90625 7.69531 1.33594 10.3125 2.9375Z"
						fill="white"
						fill-opacity="0.7"
					/>
				</svg>
			</div>
			<view692 />
		</div>
	</div>
</template>

<script>
import View692 from './View692'
export default {
	name: 'X1152',
	components: {
		View692,
	},
	emits: ['click'],
	props: ['className', 'title', 'durationText'],
}
</script>

<style>
.x1-11 {
	background-color: var(--storm-dust);
	border-radius: 12px;
	height: 90px;
	margin-left: 4px;
	position: relative;
	width: 300px;
}

.image-13 {
	height: 86px;
	left: 4px;
	position: absolute;
	top: 3px;
	width: 293px;
}

.view-189 {
	height: 75px;
	left: 25px;
	position: absolute;
	top: 7px;
	width: 274px;
  z-index: 2;
}

.text-254 {
	left: 0;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 57px;
}

.x01-17 {
	left: 38px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 3px;
	width: 203px;
}

.text-255 {
	left: 0;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 6px;
	white-space: nowrap;
}

.x1-11.x1-12 {
	margin-left: 5px;
}

/* Неактивное состояние - прозрачная рамка */
.x1-11.lesson-card-inactive .card-border-x1 {
	border-color: transparent;
	border-width: 8px;
}

/* Активное состояние - темно-серая рамка */
.x1-11.lesson-card-active .card-border-x1 {
	border-color: transparent !important;
	border-width: 8px !important;
}

.x1-11.lesson-card-selected .card-border-x1 {
	border-color: #4b4b4b !important;
	border-width: 8px !important;
}

/* Hover для неактивной карточки - полупрозрачная рамка */
.x1-11:not(.lesson-card-active):hover .card-border-x1 {
	border-color: transparent !important;
	border-width: 8px !important;
}
</style>
